import React, { useContext } from 'react';
import { Card } from 'lucid-components-react';
import { useSiteMetadata, lucidColors } from '@lucid/gatsby-theme-lucid';

import { Drupal_ParagraphConsiderationCards } from '../../generated/graphql';
import Link from '../link/link';
import LayoutContext from '../../contexts/layoutContext';
import LazyLoad from 'react-lazyload';

interface Props {
  entity: Drupal_ParagraphConsiderationCards;
}

const TemplateCard = ({ entity, ...rest }: Props) => {
  const { fieldAltText, fieldCardHeader, fieldImage, fieldLink } = entity;
  const { productUrl } = useSiteMetadata();
  const { language } = useContext(LayoutContext);

  return (
    <Card variant="interactive" css={{ height: '400px' }} {...rest}>
      <Link
        to={`${productUrl}/${language.urlLangPrefix}documents/editNewOrRegister/${fieldLink}`}
        underline="none"
        css={{ height: '100%', width: '100%' }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            height: '100%'
          }}
        >
          <Card.Image css={{ position: 'relative' }}>
            <LazyLoad offset={100}>
              <img
                src={fieldImage!}
                alt={fieldAltText!}
                css={{
                  maxHeight: '100%',
                  maxWidth: '100%',
                  top: 0,
                  bottom: 0,
                  position: 'absolute',
                  margin: 'auto'
                }}
              />
            </LazyLoad>
          </Card.Image>
          <Card.Content
            p={6}
            css={{
              borderTop: `1px solid ${lucidColors.coolGrey[30]}`,
              height: '6rem',
              padding: '0 1.5rem',
              flex: '0 1 auto'
            }}
          >
            <Card.Title
              css={{
                margin: 'auto 0',
                fontSize: '1.25rem',
                fontWeight: 500
              }}
              as="h3"
              variant="cardTitle"
            >
              {fieldCardHeader}
            </Card.Title>
          </Card.Content>
        </div>
      </Link>
    </Card>
  );
};

export default TemplateCard;
